<template>
    <v-col
        class="trigger-container"
        :class="{ 'trigger-container-active': isActive }"
        cols="auto"
    >
        <element-trigger-icon
            :trigger="trigger"
        />
    </v-col>
</template>

<script>

import ElementTriggerIcon from "./element-trigger-icon.vue";

export default {
    name: "ElementTriggerColumn",
    components: {ElementTriggerIcon},
    props: {
        trigger: {},
    },
    computed: {
        isActive() {
            if (!this.trigger) return false;
            if (Array.isArray(this.trigger)) return this.trigger.length > 0;
            if (_.isString(this.trigger)) return this.trigger.trim().length > 0;

            return false;
        }
    },
};
</script>

<style scoped>
.trigger-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 20px;
}

.trigger-container-active {
    background-color: var(--color-easescreen-primary);
}
</style>
